import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetTagsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetTagsResponse) => ReactElement
}

const GetAiEnvironmentTagsRequest = ({
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/tags`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiEnvironmentTagsRequest
